import PostView from "views/Posts/PostView";
import ForgotPassword from "views/ForgotPassword/ForgotPassword";
import ResetPassword from "views/ResetPassword/ResetPassword";

var pagesRoutes = [
  {
    path: "/pages/posts",
    name: "List Post",
    mini: "LP",
    component: PostView,
    needAuth: false
  },
  {
    path: "/pages/forgot-password",
    name: "Forgot Password",
    mini: "FP",
    component: ForgotPassword,
    needAuth: false
  },
  {
    path: "/pages/reset-password",
    name: "Reset Password",
    mini: "FP",
    component: ResetPassword,
    needAuth: false
  }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pagesRoutes.jsx